const startReadMore = (event: Event) => {
  const target = event.target as HTMLElement
  target.querySelectorAll<HTMLDivElement>('.js-read-more:not([data-read-more-initialized])').forEach(elm => {
    elm.dataset.readMoreInitialized = 'true'
    elm.classList.add('is-truncated')
    elm.addEventListener('click', () => {
      elm.classList.toggle('is-truncated')
      elm.classList.toggle('is-not-truncated')
    })
  })
}

document.addEventListener('turbo:load', startReadMore)
document.addEventListener('turbo:frame-load', startReadMore)
